import React, { useEffect, useState } from "react";
const CaptchaControl = ({ capchaCorrectValue, label, onClick, newArr }) => {
  const alphaNums = [];

  // Add uppercase letters
  for (let i = 65; i <= 90; i++) {
    alphaNums.push(String.fromCharCode(i));
  }

  // Add lowercase letters
  for (let i = 97; i <= 122; i++) {
    alphaNums.push(String.fromCharCode(i));
  }

  // Add numbers
  for (let i = 0; i <= 9; i++) {
    alphaNums.push(i.toString());
  }

  const [emptyArr, setemptyArr] = useState([]);

  useEffect(() => {
    setemptyArr(newArr);
  }, [newArr]);

  useEffect(() => {
    let arry = [];
    for (let i = 1; i <= 7; i++) {
      arry.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    setemptyArr(arry);
    capchaCorrectValue(false);
  }, []);

  const refreshCaptcha = () => {
    let refreshArr = [];
    for (let j = 1; j <= 7; j++) {
      refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
    }
    setemptyArr(refreshArr);
  };
  const handleChange = (e) => {
    emptyArr.join("") === e.target.value
      ? capchaCorrectValue(true)
      : capchaCorrectValue(false);
    if (emptyArr.join("") !== e.target.value) {
      document.getElementById("captchaError").textContent =
        "Captcha Not Matched!!";
    } else {
      document.getElementById("captchaError").textContent = "";
    }
  };
  return (
    <>
      {emptyArr.length > 0 ? (
        <>
          <div className="d-flex align-items-center justify-">
            <div className="mr-2">
              {" "}
              <h4
                className="m-0"
                style={{ backgroundColor: "#f3f3f3", padding: "8px 7px" }}
              >
                {emptyArr.join("")}
              </h4>
            </div>
            <div className="mr-2 mx-3">
              <img
                width={"28px"}
                src="/images/captcha.png"
                alt="upload"
                onClick={() => {
                  refreshCaptcha();
                  onClick();
                }}
              />
            </div>
            <div className="">
              <input
                name={label}
                className="form-control mb-0"
                placeholder="Enter Captcha"
                onChange={handleChange}
                value={undefined}
                id="captchaInput"
              />
            </div>
          </div>
          <span className="errorMessage" id="captchaError"></span>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default CaptchaControl;
